import React, {Component} from "react";
import ModalContainer from "../../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import Api from "../../../../../../Services/Api";
import {defaultTableChange} from "../../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";

class InventoryUnitDetailHistory extends Component {
    tableConfig = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const { page, rowsPerPage } = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "date",
            label: "Tgl. Transaksi",
            options: {
                sort: false,
            },
        },
        {
            name: "hour",
            label: "Jam",
            options: {
                sort: false,
            },
        },
        {
            name: "trxCode",
            label: "Jenis Transaksi",
            options: {
                sort: false,
            },
        },
        {
            name: "trxId",
            label: "Ref. Doc No.",
            options: {
                sort: false,
            },
        },
        {
            name: "locator",
            label: "Locator",
            options: {
                sort: false,
            },
        },
        {
            name: "kodeCabang",
            label: "Kd. Cabang",
            options: {
                sort: false,
            },
        },
    ]

    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }
    }

    componentDidMount() {
        this.fetchDataHistory(this.props.selectedData.nosin);
    }

    parseTrxTime = (trxTime) => {
        const [datePart, timePart] = trxTime.split(" ");
        const formattedTime = timePart.split(":").slice(0, 2).join(":");
        return { tglTransaksi: datePart, jam: formattedTime };
    };

    fetchDataHistory = async (body) => {
        try {
            let response = await Api.create("NAGAMAS_TRANSACTION").getHistoryUnitInventory(body);
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataTable: response.data.data?.map(item => ({
                        ...item,
                        trxId: item?.trxId||'',
                        locator: item?.location?.nameLocation,
                    })),
                    pagination:{
                        ...prevState.pagination,
                        totalData: response.data.data?.length
                    }
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <SimpleModal
                title="Riwayat Mutasi Unit"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                            <div id="grid-1">
                                <SimpleInput
                                    id="input_text_kode_variant"
                                    name="kodeVariant"
                                    label="Kode Varian"
                                    readOnly={true}
                                    value={this.props.selectedData.kodeVariant}
                                />
                                <SimpleInput
                                    id="input_text_nama_variant"
                                    name="namaVariant"
                                    label="Nama Varian"
                                    readOnly={true}
                                    value={this.props.selectedData.namaVariant}
                                />
                            </div>

                            <div id="grid-2">
                                <SimpleInput
                                    id="input_text_noMesin"
                                    name="noMesin"
                                    label="No. Mesin"
                                    readOnly={true}
                                    value={this.props.selectedData.nosin}
                                />
                                <SimpleInput
                                    id="input_text_noRangka"
                                    name="noRangka"
                                    label="No. Rangka"
                                    readOnly={true}
                                    value={this.props.selectedData.noka}
                                />
                            </div>
                        </div>

                        <SimpleDataTable
                            key={`${this.state.pagination.totalData}-${this.state.pagination.page}`}
                            data={this.state.dataTable}
                            columns={this.tableConfig}
                            toCount={this.state.pagination.totalData}
                            rowsPerPage={this.state.pagination.limit}
                            page={this.state.pagination.page - 1}
                            options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                        />

                        <div style={{textAlign: "right", marginTop: "10px"}}>
                            <SimpleButton
                                onClick={() => this.props.onClickClose()}
                                secondary
                                text={"Kembali"}
                            />
                        </div>
                    </ModalContainer>
                }
            />
        )
    }
}

export default InventoryUnitDetailHistory;